import { Spinner } from '@/components/Spinner';
import { useDropdown } from '@/hooks/useDropdown';
import { AssignNewRoleForm } from './AssignNewRoleForm';
import { useRoleAgents } from './hooks/useRoleAgents';

export const AssignNewRoleFormContainer = ({
  activeTab,
}: {
  activeTab: 'admin' | 'club' | 'customer' | 'affiliate';
}) => {
  const { data: roleTypes, isLoading: rolesLoading } = useDropdown('role');
  const activeRoleTypeId = roleTypes?.find(({ label }) => label.toLowerCase() === activeTab)?.value ?? '';
  const { agents, isLoading: agentsLoading } = useRoleAgents(activeTab, activeRoleTypeId);
  const username = sessionStorage.getItem('fullName');

  const filteredAgents = agents.filter((agent) => agent.userName !== username);

  const { data: availableRoles, isLoading: availableRolesLoading } = useDropdown(
    'roleType',
    activeRoleTypeId,
    undefined,
    undefined,
    Boolean(activeRoleTypeId),
  );

  const loading = rolesLoading || agentsLoading || availableRolesLoading;
  return loading ? (
    <Spinner />
  ) : (
    <AssignNewRoleForm
      activeTab={activeTab}
      agents={filteredAgents ?? []}
      availableRoles={availableRoles || []}
      roleType={roleTypes || []}
    />
  );
};
